import { useEffect, useState } from "react";
import ChimeCard from "./ChimeCard";
import { setUpThreadData } from './functions'
import axios from "axios";
import { deruptFeedContractAddress, stacksApi, clientNetwork } from "../../lib/constants";
import { userSession, getUserData } from "../../services/auth";
// import { cvToJSON, hexToCV } from "@stacks/transactions";
import { } from "../../lib/constants"; import './style.scss';

const Thread = ({
    baseTxId, hex, mutedList, setReplyOpen, profilePrincipal, threading, userSettings,
    playList, setPlayList, mediaCurrentTime, setMediaCurrentTime,
    openMediaPlayer, setOpenMediaPlayer,
    // currentTime, setCurrentTime,
    index, selectedChimeTx, setSelectedChimeTx,

    setShowUserContractDeployModal,
    setShowWoopsModal,
    setOpenConfirmModal,
    userContractStatus,

    txId,
    setTxId,
    tx_Id,
    setTx_Id
}) => {
    const [landing, setLanding] = useState(true);
    const [basedata, setBaseData] = useState([]);
    const [parentData, setParentData] = useState([]);
    const [grandParentData, setGrandParentData] = useState([]);
    const [parentTxId, setParentTxId] = useState({ tx: '', state: false });
    const [grandParentTxId, setGrandParentTxId] = useState({ tx: '', state: false });

    let authUser;
    if (userSession.isUserSignedIn()) {
        authUser = getUserData().profile.stxAddress.testnet;
        //authUser =  getUserData().profile.stxAddress.testnet;
    }


    async function initBase(hexVal, txVal, set) {
        const chimeData = await setUpThreadData(hexVal, txVal, authUser, profilePrincipal, mutedList, true);
        const { replyTo: replyTx } = chimeData ?? { replyTo: null };
        if (replyTx && typeof (set) === 'function') set({ tx: replyTx, state: true })
        setBaseData([chimeData])
    }

    async function initThreading(tx, set, setData) {
        const { data: { events } } = await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/extended/v1/tx/${tx}`);
        let chimedata = events.filter((res) => res.contract_log && res.contract_log.contract_id === deruptFeedContractAddress)
        if (chimedata.length < 0) return
        const { contract_log: { value: { hex } } } = chimedata[0];
        chimedata = await setUpThreadData(hex, tx, authUser, profilePrincipal, mutedList, false);
        const { replyTo: replyTx } = chimedata ?? { replyTo: null };
        if (replyTx && typeof (set) === 'function') set({ tx: replyTx, state: true })
        setData([chimedata])
    }

    useEffect(() => {
        if (landing) {
            initBase(hex, baseTxId, setParentTxId);
            setLanding(false)
        }
    }, [])

    useEffect(() => {
        if (parentTxId.state && threading) {
            initThreading(parentTxId.tx, setGrandParentTxId, setParentData);
            setParentTxId({ tx: parentTxId.tx, state: false })
        }
    }, [parentTxId])

    useEffect(() => {
        if (grandParentTxId.state && threading) {
            initThreading(grandParentTxId.tx, '', setGrandParentData);
            setGrandParentTxId({ tx: grandParentTxId.tx, state: false })
        }
    }, [grandParentTxId])

    useEffect(() => {
    }, [basedata, parentData, grandParentData])

    return (
        <div className="family-of-chimes-container">
            <div className="chime-bumper" />

            {/* Grandparent */}
            {grandParentData && grandParentData.map(({
                contenttx,
                publisher, name, contentOrigin, replyTo,
                content, attachmentUri, thumbNailUri,
                imageType, audioType, videoType,
                likes, dislikes, replies,
                liked, disliked, impressions, replied
            }, i) => (
                <ChimeCard key={i}
                    contenttxId={contenttx}
                    authorPrincipal={publisher || profilePrincipal} authorName={name}
                    contentOrigin={contentOrigin} replyTxId={replyTo}
                    // 
                    content={content} attachmentUrl={attachmentUri} thumbnailUrl={thumbNailUri}
                    imageType={imageType} audioType={audioType} videoType={videoType}
                    likeCount={likes} disLikeCount={dislikes} replyCount={replies}
                    liked={liked} disliked={disliked} impressions={impressions} replied={replied}
                    setReplyOpen={setReplyOpen}
                    threading={threading}

                    playList={playList} setPlayList={setPlayList} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}
                    openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                    // currentTime={currentTime} setCurrentTime={setCurrentTime}

                    userSettings={userSettings}
                    index={index + 'gpd'}
                    selectedChimeTx={selectedChimeTx}
                    setSelectedChimeTx={setSelectedChimeTx}

                    setShowUserContractDeployModal={setShowUserContractDeployModal}
                    setShowWoopsModal={setShowWoopsModal}
                    setOpenConfirmModal={setOpenConfirmModal}
                    userContractStatus={userContractStatus}

                    txId={txId}
                    setTxId={setTxId}
                    tx_Id={tx_Id}
                    setTx_Id={setTx_Id}
                />
            ))}

            {/* Parent */}
            {parentData && parentData.map(({
                contenttx,
                publisher, name, contentOrigin, replyTo,
                content, attachmentUri, thumbNailUri,
                imageType, audioType, videoType,
                likes, dislikes, replies,
                liked, disliked, impressions, replied
            }, i) => (
                <ChimeCard key={i}
                    contenttxId={contenttx}
                    authorPrincipal={publisher || profilePrincipal} authorName={name}
                    contentOrigin={contentOrigin} replyTxId={replyTo}
                    // 
                    content={content} attachmentUrl={attachmentUri} thumbnailUrl={thumbNailUri}
                    imageType={imageType} audioType={audioType} videoType={videoType}
                    likeCount={likes} disLikeCount={dislikes} replyCount={replies}
                    liked={liked} disliked={disliked} impressions={impressions} replied={replied}
                    setReplyOpen={setReplyOpen}
                    threading={threading}

                    playList={playList} setPlayList={setPlayList} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}
                    openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                    // currentTime={currentTime} setCurrentTime={setCurrentTime}

                    userSettings={userSettings}
                    index={index + 'pd'}
                    selectedChimeTx={selectedChimeTx}
                    setSelectedChimeTx={setSelectedChimeTx}

                    setShowUserContractDeployModal={setShowUserContractDeployModal}
                    setShowWoopsModal={setShowWoopsModal}
                    setOpenConfirmModal={setOpenConfirmModal}
                    userContractStatus={userContractStatus}

                    txId={txId}
                    setTxId={setTxId}
                    tx_Id={tx_Id}
                    setTx_Id={setTx_Id}
                />
            ))}

            {/* Base */}
            {basedata && basedata.map(({
                contenttx,
                publisher, name, contentOrigin, replyTo,
                content, attachmentUri, thumbNailUri,
                imageType, audioType, videoType,
                likes, dislikes, replies,
                liked, disliked, impressions, replied
            }, i) => (
                <ChimeCard key={i}
                    contenttxId={contenttx}
                    authorPrincipal={publisher || profilePrincipal} authorName={name}
                    contentOrigin={contentOrigin} replyTxId={replyTo}
                    // 
                    content={content} attachmentUrl={attachmentUri} thumbnailUrl={thumbNailUri}
                    imageType={imageType} audioType={audioType} videoType={videoType}
                    likeCount={likes} disLikeCount={dislikes} replyCount={replies}
                    liked={liked} disliked={disliked} impressions={impressions} replied={replied}
                    setReplyOpen={setReplyOpen}
                    threading={threading}

                    playList={playList} setPlayList={setPlayList} mediaCurrentTime={mediaCurrentTime} setMediaCurrentTime={setMediaCurrentTime}
                    openMediaPlayer={openMediaPlayer} setOpenMediaPlayer={setOpenMediaPlayer}
                    // currentTime={currentTime} setCurrentTime={setCurrentTime}

                    userSettings={userSettings}
                    index={index + 'bd'}
                    selectedChimeTx={selectedChimeTx}
                    setSelectedChimeTx={setSelectedChimeTx}

                    setShowUserContractDeployModal={setShowUserContractDeployModal}
                    setShowWoopsModal={setShowWoopsModal}
                    setOpenConfirmModal={setOpenConfirmModal}
                    userContractStatus={userContractStatus}

                    txId={txId}
                    setTxId={setTxId}
                    tx_Id={tx_Id}
                    setTx_Id={setTx_Id}
                />
            ))}

        </div>
    )
}

export default Thread;